import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import { useSettingsContext } from './settings';
import Iconify from './iconify';

const ThemeModeButton = ({ sx }) => {
  const settings = useSettingsContext();

  const onChange = () => {
    const themeMode = settings.themeMode === 'light' ? 'dark' : 'light';
    settings.onUpdate('themeMode', themeMode);
  };

  const icon = settings.themeMode === 'light' ? 'ic:baseline-light-mode' : 'ic:baseline-dark-mode';

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', ...sx }}>
      <IconButton aria-label="theme" color="inherit" onClick={onChange}>
        <Tooltip title={settings.themeMode}>
          <Iconify size={24} icon={icon} />
        </Tooltip>
      </IconButton>
    </Box>
  );
};

export default ThemeModeButton;

ThemeModeButton.propTypes = {
  sx: PropTypes.object,
};
